import { graphql, useStaticQuery } from 'gatsby';
import React, { FC, useMemo } from 'react';
import styled from 'styled-components';

import { IMemberHomeStepPageContent } from '@ui/routes/Dashboard/MemberHomeStep/MemberHomeStep.component';
import {
	dependents,
	helpCenter,
	logout,
	profile,
} from '@ui/routes/Dashboard/MemberHomeStep/QuickLinks';

import useMemberInfo, { B2BMember, B2BMemberKind } from '@hooks/useMemberInfo';

import { keysToCamel } from '@utils/butter';
import { exists } from '@utils/general';

import { b2bMember, b2bMemberName } from '@graphql/fragments/b2bMember';

import ProfileDropdown from './ProfileDropdown.component';

interface IProfileDropdownWrapperProps {
	className?: string;
}

const ProfileDropdownWrapper: FC<IProfileDropdownWrapperProps> = ({ className }) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "member-home-step" }) {
				help_header
				account_header
				logout_header
				dependents_header
			}
		}
	`);

	const refinedContent: IMemberHomeStepPageContent = keysToCamel(
		pageContent
	) as IMemberHomeStepPageContent;

	const { memberInfo } = useMemberInfo<B2BMember>([{ name: b2bMemberName, node: b2bMember }]);

	const showDependents = useMemo(
		() => memberInfo?.b2b?.kind === B2BMemberKind.primary && exists(memberInfo?.b2b?.customer),
		[memberInfo?.b2b?.customer, memberInfo?.b2b?.kind]
	);

	const links = showDependents
		? [
				profile({ header: refinedContent.accountHeader }),
				dependents({ header: refinedContent.dependentsHeader }),
				helpCenter({ header: refinedContent.helpHeader }),
				logout({ header: refinedContent.logoutHeader }),
		  ]
		: [
				profile({ header: refinedContent.accountHeader }),
				helpCenter({ header: refinedContent.helpHeader }),
				logout({ header: refinedContent.logoutHeader }),
		  ];

	return (
		<ProfileDropdown
			className={className}
			name={memberInfo?.displayNameFirst ?? ''}
			links={links}
		/>
	);
};

export default styled(ProfileDropdownWrapper)`
	align-self: flex-end;
`;
